import * as Sentry from "@sentry/react";

import { isDevOrStaging } from "common/utilities/environment";

const logless: typeof console.log = () => undefined;

export const logger = {
  error: (message: string, cause?: unknown) => {
    void Sentry.captureException(new Error(message, { cause }));
    console.error(message);
  },
  log: isDevOrStaging ? console.log : logless,
};
